import React from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal, Icon, Button } from "semantic-ui-react";
import LabelledButton from '../LabelledButton/LabelledButton';
import { save } from '../../actions/authentication';
import { removeSilo } from '../../actions/silos';

const inlineStyle = {
  modal: {
    marginTop: "25px !important",
    marginLeft: "auto",
    marginRight: "auto"
  },
  field: {
    marginTop: '10px'
  }
};

class RemoveSiloMessage extends React.Component {

  state = {
    open: false
  };

  handleModal = open => {
    let state = {
      open: open
    };

    this.setState(state);
  };

  handlePositive = async (state) => {
    const { authenticated, save } = this.props;
    await this.props.removeSilo(this.props.id);

    if (authenticated)
      await save();
  }

  render() {

    const { t } = this.props;
    const { open } = this.state;
    
    return(
      <Modal
        style={inlineStyle.modal}
        open={open}
        closeIcon={false}
        closeOnDimmerClick={false}
        onClose={() => this.handleModal(false)}
        trigger={
          <LabelledButton
            label={t("silo.actions.delete")}
            icon="trash"
            onClick={() => this.handleModal(true)}
          />
        }
      >
        <Modal.Header>{t("silo.remove.header")}</Modal.Header>
        <Modal.Content>
          {t("silo.remove.message")}
        </Modal.Content>
        <Modal.Actions>
          <Button.Group>
            <Button
              type="button"
              onClick={() => this.handleModal(false)}
              color="grey"
            >
              <Icon name="close" />
              {t("buttons.cancel")}
            </Button>
            <Button type="button" onClick={_ => this.handlePositive(this.state)} color="green">
              <Icon name="checkmark" />
              {t("buttons.ok")}
            </Button>
          </Button.Group>
        </Modal.Actions>
      </Modal>
    );
  }
}

const RemoveSiloMessage_i18nWrapper = withNamespaces('translation')(RemoveSiloMessage);

function mapStateToProps(state) {
  const authenticated = state.auth.authenticated;
  return {
    authenticated
  };
}

export default connect(mapStateToProps, {removeSilo, save})(RemoveSiloMessage_i18nWrapper);